export default {
    url: '/general',
    template: `
        <courses-courses-edit-occurrence-automated-planning-group-add-general
            planning-group="vm.planningGroup"
            sites="vm.sites"
            course-versions="vm.courseVersions"
        />
    `,
    resolve: {
        sites (SiteResource) {
            return SiteResource.query({ planningGroupSites: true }).$promise;
        },
        courseVersions (CourseVersionResource, $stateParams) {
            return CourseVersionResource.query({
                courseId: $stateParams.id,
                isPlanningGroupSearch: true
            }).$promise;
        }
    },
    controller ($scope, sites, courseVersions) {
        $scope.$parent.vm.step = 1;
        this.planningGroup = $scope.$parent.vm.planningGroup;
        this.sites = sites;
        this.courseVersions = courseVersions;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/edit/occurrence/automated/add/general/index.js